import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-no-header',
  templateUrl: './no-header.component.html',
  styleUrls: ['./no-header.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class NoHeaderComponent  implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
